import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Messenger from '../../components/_common/Messenger/Messenger'
import ProcessSlider from '../../components/process/ProcessSlider/ProcessSlider'
import Footer from '../../components/_common/Footer/Footer'
import { MOBILE_VIEW } from '../../constants/dimentions'
import HeadMeta from '../../components/_common/HeadMeta'

Process.propTypes = {
  screenWidth: PropTypes.number
}

function Process (props) {
  const { screenWidth } = props
  return (
    <Fragment>
      <HeadMeta url='process' />
      <div className='process fadeIn'>
        <ProcessSlider screenWidth={screenWidth} />
        <Messenger />
      </div>
      { screenWidth <= MOBILE_VIEW && <Footer /> }
    </Fragment>
  )
}

export default Process
